import { useTranslation } from "react-i18next";
import Logo from "@/pages/home/components/Logo";
import { appHomeUrl } from "@/lib/payHost";
import { MERCHANT } from "@/lib/merchant";

/** Who the customer is paying: shown on checkout and the pay page, before payment. */
export default function MerchantOfRecord({ className = "" }: { className?: string }) {
  const { t } = useTranslation();
  return (
    <section
      aria-labelledby="merchant-of-record"
      className={`rounded-xl border border-background-200/70 bg-background-50 p-4 text-left ${className}`}
    >
      <h2 id="merchant-of-record" className="text-xs font-semibold uppercase tracking-wider text-foreground-500">
        {t("common.merchant.title")}
      </h2>
      <div className="mt-3">
        <Logo to={appHomeUrl()} />
      </div>
      <dl className="mt-3 space-y-1 text-xs leading-relaxed text-foreground-600">
        <div>
          <dt className="sr-only">{t("common.merchant.company")}</dt>
          <dd className="font-semibold text-foreground-950">
            {MERCHANT.legalName}{" "}
            <span className="font-normal text-foreground-600">
              ({t("common.merchant.tradingAs", { name: MERCHANT.tradingName })})
            </span>
          </dd>
        </div>
        <div>
          <dt className="sr-only">{t("common.merchant.uic")}</dt>
          <dd>{t("common.merchant.uicValue", { uic: MERCHANT.uic })}</dd>
        </div>
        <div>
          <dt className="sr-only">{t("common.merchant.address")}</dt>
          <dd>{t("home.contact.address")}</dd>
        </div>
        <div>
          <dt className="sr-only">{t("common.merchant.website")}</dt>
          <dd>
            <a href={MERCHANT.website} className="text-primary-600 hover:underline">
              {MERCHANT.website.replace(/^https:\/\//, "")}
            </a>
            {" · "}
            <a href={`mailto:${MERCHANT.email}`} className="text-primary-600 hover:underline">
              {MERCHANT.email}
            </a>
            {" · "}
            <a href={`tel:${MERCHANT.phone.replace(/\s/g, "")}`} className="hover:underline">
              {MERCHANT.phone}
            </a>
          </dd>
        </div>
      </dl>
    </section>
  );
}
